module.exports = __webpack_public_path__ + "staticcomp/img/share.a42193f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/8/share.jpg
// module id = 2v9v
// module chunks = 39